import React from 'react';
import { useTranslation } from 'react-i18next';

type StatusType = 'active' | 'pending' | 'declined' | string; // Allow other statuses but style known ones

interface StatusTagProps {
  status: StatusType;
}

const getStatusStyles = (status: StatusType): string => {
  switch (status?.toLowerCase()) {
    case 'active':
      return 'bg-green-100 text-green-700';
    case 'pending':
      return 'bg-orange-100 text-orange-700'; // Using orange for pending
    case 'declined':
      return 'bg-red-100 text-red-700';
    default:
      return 'bg-gray-100 text-gray-700'; // Default style for unknown statuses
  }
};

export const StatusTag: React.FC<StatusTagProps> = ({ status }) => {
  const { t } = useTranslation();

  // Attempt to translate the status, fallback to the status string itself
  const statusText = t(`teamMembers.status.${status?.toLowerCase()}`, status?.charAt(0).toUpperCase() + status?.slice(1));

  return (
    <span 
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusStyles(status)}`}
    >
      {statusText}
    </span>
  );
}; 